import ModalFormLayout from "../generic/form-layout";
import Body from "./form-body";
import Buttons from "../generic/button/collection";
import buttons from "./form-buttons";

import environment from "../../common/environment";
import store from "../../utils/webstorage";
import { CONSTANTS } from "../../config/webstorage";

const CUSTOM_ROLES = CONSTANTS.CUSTOM_ROLES;

class FormBody extends ModalFormLayout {
  ui() {
    return {
      removeBtn: "button.remove",
    };
  }

  events() {
    return {
      submit: "_onSubmit",
      "click @ui.removeBtn": _.debounce(this._onRemove, 200),
    };
  }

  onBeforeShow() {
    // attach form fields
    this.body.show(
      new Body({
        collection: this.options.collection,
      })
    );

    // attach form buttons
    this.buttons.show(
      new Buttons({
        buttons,
        meta: this.options,
      })
    );
  }

  _onSubmit(e) {
    e.preventDefault();

    // extract submitted form data
    const selectedRoleIds = _.keys(Backbone.Syphon.serialize(this));

    // is there at least one role selected?
    if (selectedRoleIds.length) {
      // make sure roleIds are numeric
      const roleIds = selectedRoleIds.map((id) => +id);

      // persist to localstorage
      store.add(CUSTOM_ROLES, roleIds);
    } else {
      // remove item from localstorage
      store.remove(CUSTOM_ROLES);
    }

    // force app to reload
    this._reloadApp();
  }

  _onRemove(e) {
    e.preventDefault();

    // remove item from localstorage
    store.remove(CUSTOM_ROLES);

    // force app to reload
    this._reloadApp();
  }

  _reloadApp() {
    document.location.assign(`${environment.getAppHost()}/`);
  }
}

export { FormBody as default };
